import { Views } from "@/views";
import { Router, createRouter, createWebHistory } from "vue-router";
import { authenticated } from "./authenticated.routes";
import { guardAuth } from "./guards";
import { unauthenticated } from "./unauthenticated.routes";

const router: Router = createRouter({
  history: createWebHistory(),
  routes: [
    ...unauthenticated,
    ...authenticated,
    { path: "/:pathMatch(.*)*", name: "notFound", component: Views.NotFound },
  ],
  linkExactActiveClass: "active",
});

router.beforeEach(guardAuth);

export default router;
